const VPCSC_CHECK_FAILED_CODE = 'auth/vpcsc-check-failed';

/** The Sentry tag recording what a refusal did to the user. */
export const VPCSC_OUTCOME_TAG = 'vpcsc-outcome';

export enum VpcscRefusalOutcome {
  /** The sign-in carried on without the refused update. */
  SESSION_KEPT = 'SESSION_KEPT',
  /** The sign-in ended, and the user cannot get into the app. */
  SIGNED_OUT = 'SIGNED_OUT',
  /** An API request failed. */
  REQUEST_FAILED = 'REQUEST_FAILED',
}

// Bounds the walk through wrapping errors, so a cyclic `cause` cannot loop.
const MAX_WRAPPING_DEPTH = 5;

const isRefusal = (error: unknown, depth: number): boolean => {
  if (depth > MAX_WRAPPING_DEPTH || typeof error !== 'object' || error === null) {
    return false;
  }
  if ('code' in error && error.code === VPCSC_CHECK_FAILED_CODE) {
    return true;
  }
  return (
    ('networkError' in error && isRefusal(error.networkError, depth + 1)) ||
    ('cause' in error && isRefusal(error.cause, depth + 1))
  );
};

/**
 * Whether the user's network refused a request to Identity Platform under VPC Service Controls, raised directly or
 * as the `networkError` or `cause` of an error wrapping it.
 */
export const isVpcscCheckFailedError = (error: unknown): boolean => isRefusal(error, 0);
